/**
 * CLEARO FAQ — <clearo-faq>
 * - Smooth open/close for <details> answers (height animation), one open at a time
 * - Live search across questions and answers; hides empty groups
 * Without JS the <details> elements still open and close normally.
 * Markup & styles: sections/clearo-faq.liquid.
 */
(() => {
  if (customElements.get('clearo-faq')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DURATION = 320;
  const EASE = 'cubic-bezier(0.2, 0.7, 0.2, 1)';

  class ClearoFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.groups = Array.from(this.querySelectorAll('[data-group]'));

      this.items.forEach((item) => {
        const summary = item.querySelector('summary');
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          item.open ? this.close(item) : this.open(item);
        });
      });

      const wrap = this.querySelector('[data-search-wrap]');
      this.search = this.querySelector('[data-search]');
      this.empty = this.querySelector('[data-empty]');
      if (wrap && this.search) {
        wrap.hidden = false;
        this.search.addEventListener('input', () => this.filter(this.search.value));
      }

      // Theme editor: open a question when its block is selected
      document.addEventListener('shopify:block:select', (event) => {
        if (this.items.includes(event.target)) this.open(event.target, false);
      });
    }

    open(item, animate = true) {
      this.items.forEach((other) => other !== item && other.open && this.close(other));
      item.open = true;
      if (!animate || reducedMotion.matches) return;
      const panel = item.querySelector('.clr-faq__a');
      const height = panel.scrollHeight;
      panel.animate(
        [
          { height: '0px', opacity: 0 },
          { height: `${height}px`, opacity: 1 },
        ],
        { duration: DURATION, easing: EASE }
      );
    }

    close(item) {
      if (reducedMotion.matches) {
        item.open = false;
        return;
      }
      const panel = item.querySelector('.clr-faq__a');
      const anim = panel.animate(
        [
          { height: `${panel.scrollHeight}px`, opacity: 1 },
          { height: '0px', opacity: 0 },
        ],
        { duration: DURATION * 0.8, easing: EASE }
      );
      anim.onfinish = () => (item.open = false);
    }

    filter(query) {
      const q = query.trim().toLowerCase();
      let shown = 0;
      this.items.forEach((item) => {
        const match = !q || item.textContent.toLowerCase().includes(q);
        item.hidden = !match;
        if (match) shown++;
      });
      this.groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-item]:not([hidden])');
      });
      if (this.empty) this.empty.hidden = shown > 0;
    }
  }

  customElements.define('clearo-faq', ClearoFaq);
})();
